import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { CallAPI, CapitalizeWord, GetCookieFunction } from "../utils/util";

function Navigation() {
    // useLocation causes re-render on every route change,
    // ensuring cookies are re-read after login/logout
    useLocation();

    const user = GetCookieFunction("User");
    const center = GetCookieFunction("Center");
    const userType = (user && user.type) ? user.type : "login";

    const [menuOpen, setMenuOpen] = useState(false);
    const [openSection, setOpenSection] = useState(null);
    const menuRef = useRef(null);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    // Close menu when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menuOpen]);

    const isAdmin = user && (user.admin === 1 || user.type === "centeradmin" || user.type === "executive");

    return (
        <div className="topNav">
            {userType !== "login" && (
                <div className="hamburger-wrapper" ref={menuRef}>
                    <button
                        className="hamburger-btn"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Menu"
                        aria-expanded={menuOpen}
                    >
                        <span className="hamburger-icon" />
                        <span className="hamburger-icon" />
                        <span className="hamburger-icon" />
                    </button>
                    {menuOpen && (
                        <div className="hamburger-menu">
                            <a href="/" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">🏠</span>Home</a>
                            
                            <div className="hamburger-menu-section" onClick={() => toggleSection('patients')}>
                                <span className="hamburger-menu-icon">👤</span>Patients
                                <span className="hamburger-menu-caret">{openSection === 'patients' ? '▾' : '▸'}</span>
                            </div>
                            {openSection === 'patients' && (
                                <div className="hamburger-menu-sub">
                                    <a href="/patients/lookup" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">🔍</span>Search</a>
                                    <a href="/patients/lookup?checkedIn=true" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">📋</span>Checked-In</a>
                                    <a href="/patients/create/personal?funnel=1" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">➕</span>Register</a>
                                </div>
                            )}

                            <div className="hamburger-menu-section" onClick={() => toggleSection('schedule')}>
                                <span className="hamburger-menu-icon">📅</span>Schedules
                                <span className="hamburger-menu-caret">{openSection === 'schedule' ? '▾' : '▸'}</span>
                            </div>
                            {openSection === 'schedule' && (
                                <div className="hamburger-menu-sub">
                                    <a href="/schedule/daily" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">📋</span>Today</a>
                                    <a href="/schedule" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">📅</span>Weekly</a>
                                    <a href="/schedule/conflicts" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">⚠️</span>Conflicts</a>
                                </div>
                            )}

                            {isAdmin && (
                                <>
                                    <div className="hamburger-menu-section" onClick={() => toggleSection('admin')}>
                                        <span className="hamburger-menu-icon">⚙️</span>Admin
                                        <span className="hamburger-menu-caret">{openSection === 'admin' ? '▾' : '▸'}</span>
                                    </div>
                                    {openSection === 'admin' && (
                                        <div className="hamburger-menu-sub">
                                            <a href="/admin/users/create" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">➕</span>New Staff</a>
                                            <a href="/admin/users/lookup" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">👥</span>Manage Staff</a>
                                            <a href="/admin/center" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">🏥</span>Center Settings</a>
                                            <a href="/admin/scheduling" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">⚙️</span>Slot Configuration</a>
                                            <a href="/admin/reports" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">📊</span>Reports</a>
                                        </div>
                                    )}
                                </>
                            )}

                            <a href="/admin/users/changepass" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">🔑</span>Change Password</a>
                            <a href="/help" className="hamburger-menu-item" onClick={() => setMenuOpen(false)}><span className="hamburger-menu-icon">❓</span>Help</a>
                            <a href="/logout" className="hamburger-menu-item hamburger-menu-logout" onClick={() => {
                                setMenuOpen(false);
                                CallAPI({}, "users/logout", 'POST', () => {});
                            }}><span className="hamburger-menu-icon">🚪</span>Logout</a>
                        </div>
                    )}
                </div>
            )}

            <a href="/"><div className="topNavLogo" aria-label="SBF Logo" /></a>
            <div className="topNavTitle">EHR{center && center.name ? ` ${center.name}` : ""}</div>

            {user && user.fname && (
                <div className="topNavUserInfo">
                    <span>{CapitalizeWord(user.fname)} {CapitalizeWord(user.lname)}</span>
                    {CapitalizeWord(user.type)}
                </div>
            )}

            {userType !== "login" && (
                <a
                    href="/logout"
                    aria-label="Logout"
                    onClick={() => CallAPI({}, "users/logout", 'POST', () => {})}
                >
                    <div className="topNavLogout" />
                </a>
            )}
        </div>
    );
}

export default Navigation;
